import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebase konfigürasyonu - Firebase Console'dan alınacak
const firebaseConfig = {
  apiKey: "your-api-key",
  authDomain: "your-project.firebaseapp.com",
  projectId: "your-project-id",
  storageBucket: "your-project.appspot.com",
  messagingSenderId: "123456789",
  appId: "your-app-id"
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);

// Firestore veritabanını al
export const db = getFirestore(app);

export default app;
